export const bonuses = [
  {
    number: 1,
    title: 'The ABG Quick-Reference Cards',
    value: 17,
    image: 'https://cdn.magicpatterns.com/uploads/sEe18D2UsMqtwvh3C5bkzp/BONUS_1_ABG-EN.png',
    tagline: 'Review essential ABG concepts in a concise visual format.',
    intro:
      'I designed these educational reference cards to help you revisit selected concepts without navigating through an entire volume.',
    items: [
      'pH terminology cards',
      'PaCO₂ and HCO₃⁻ concept summaries',
      'Respiratory and metabolic disorder comparisons',
      'Acid-base terminology and abbreviations',
      'Compensation concept summaries',
      'Important interpretation considerations',
      'Visual reference layouts',
      'Quick-review questions',
    ],
    why: 'Keep essential study concepts organized in a concise format that complements the six main volumes.',
    note: '',
  },
  {
    number: 2,
    title: 'The 10-Minute ABG Study Review',
    value: 12,
    image: 'https://cdn.magicpatterns.com/uploads/cZp5xgyyTZGxdzc3EgdWb5/BONUS_2_ABG-EN.png',
    tagline: 'Make your study sessions more structured.',
    intro:
      'Sometimes you don’t need another long chapter. You need a clear way to organize a focused review session. This resource provides a repeatable structure for reviewing a selected ABG topic.',
    items: [
      'Topic selection worksheet',
      'Key concept review prompts',
      'pH, PaCO₂, and HCO₃⁻ review questions',
      'Acid-base terminology checkpoints',
      'Knowledge review questions',
      'Personal study notes template',
      'Follow-up learning checklist',
    ],
    why: 'Use a consistent format to review what you’ve learned and identify the concepts you want to revisit.',
    note: 'The ten-minute format refers to an educational study session, not mastery of ABG interpretation.',
  },
  {
    number: 3,
    title: 'The ABG Interpretation Pitfalls Library',
    value: 17,
    image: 'https://cdn.magicpatterns.com/uploads/3UGAK21kQu814UKgAtRKqG/BONUS_3_ABG-EN.png',
    tagline:
      'Study common conceptual mistakes and understand why context matters when reviewing arterial blood gases.',
    intro:
      'I designed this resource to help you identify misconceptions and understand the limitations of simplified interpretation rules.',
    items: [
      'Examples involving acidemia and acidotic processes',
      'Common misconceptions about respiratory and metabolic components',
      'Compensation concept pitfalls',
      'Examples involving potentially mixed disorders',
      'Measurement variability considerations',
      'Reference interval limitations',
      'Cases with incomplete contextual information',
      'Guided educational reflection exercises',
    ],
    why: 'Develop a more careful approach to reviewing ABG concepts and recognizing the limitations of individual measurements.',
    note: '',
  },
  {
    number: 4,
    title: 'The ABG Clinical Case Practice Expansion Pack',
    value: 17,
    image: 'https://cdn.magicpatterns.com/uploads/pXTjtUfVTWzU357MgcNWxh/BONUS_4_ABG-EN.png',
    tagline: 'Get additional opportunities to practice the concepts covered in Volume VI.',
    intro:
      'This complementary collection gives you more simulated educational cases to help reinforce your learning.',
    items: [
      'Simulated ABG case summaries',
      'Respiratory acid-base practice cases',
      'Metabolic acid-base exercises',
      'Compensation-focused scenarios',
      'Cases involving multiple findings',
      'Guided reasoning worksheets',
      'Self-assessment questions',
      'Suggested educational explanations',
    ],
    why: 'Practice organizing information, explaining your reasoning, and identifying concepts that require additional study.',
    note: '',
  },
  {
    number: 5,
    title: 'The ABG Learning Progress Checklist Collection',
    value: 12,
    image: 'https://cdn.magicpatterns.com/uploads/3yEQGXhyUiEZWvn9hK9dx1/BONUS_5_ABG-EN.png',
    tagline: 'Organize your educational review with structured checklists.',
    intro:
      'I included this collection to help you review the main topics consistently and identify areas that deserve more attention.',
    items: [
      'ABG fundamentals study checklist',
      'Acid-base disorders review checklist',
      'Interpretation principles checklist',
      'Compensation concepts review checklist',
      'Reference table review checklist',
      'Case practice checklist',
      'Knowledge-gap identification worksheet',
      'Personal learning progress tracker',
    ],
    why: 'Use structured prompts to review your educational material and keep track of topics you want to study further.',
    note: 'These checklists are educational resources, not approved clinical assessment protocols.',
  },
];
